require('./bootstrap');
window.Vue = require('vue');

require('./cart');
require('./common');

//lazy image load
import LazyLoad from "vanilla-lazyload";

new LazyLoad({
    elements_selector: ".lazyload"
});
